import {Heading, Link, River, RiverBreakout, Section, SectionIntro, Testimonial, Text} from '@primer/react-brand'
import {Spacer, SectionVisual} from './_shared'

export default function Collaboration() {
  return (
    <Section id="collaboration">
      <SectionVisual visual="mona" />

      <SectionIntro className="sh-SectionIntro" align="center" fullWidth>
        <SectionIntro.Heading as="h2" size="3">
          Work together, achieve more
        </SectionIntro.Heading>

        <SectionIntro.Description>
          Collaborate with your teams, use project management tools that sync with your projects, and code from
          anywhere, all on a single, integrated platform.
        </SectionIntro.Description>
      </SectionIntro>

      <Spacer size="40px" size1012="80px" />

      <RiverBreakout className="Collaboration-riverBreakout">
        <RiverBreakout.Visual className="Collaboration-riverBreakoutVisual">
          <div className="Collaboration-riverBreakoutVisualFrame">
            <img
              className="Collaboration-riverBreakoutVisualImage"
              src="/images/modules/site/home24/collaboration/breakout.webp"
              alt="TODO"
            />
          </div>
        </RiverBreakout.Visual>

        <RiverBreakout.Content
          className="Collaboration-riverBreakoutContent"
          trailingComponent={() => (
            <div className="Collaboration-riverBreakoutTrailingComponent">
              <Testimonial quoteMarkColor="green">
                <Testimonial.Quote>
                  It helps us onboard new software engineers and get them productive right away. We have all our source
                  code, issues, and pull requests in one place. ... GitHub is a complete platform that frees us from
                  menial tasks and enables us to do our best work.
                </Testimonial.Quote>
                <Testimonial.Name position="Application Manager at Mercedes-Benz">Fabian Faulhaber</Testimonial.Name>
              </Testimonial>
            </div>
          )}
        >
          <Text className="Collaboration-riverBreakoutContentText">
            <b>Your workflows, your way.</b> Plan effectively with an adaptable spreadsheet that syncs with your work.
          </Text>
          <Link href="#TODO">Jump into GitHub Projects</Link>
        </RiverBreakout.Content>
      </RiverBreakout>

      <River className="Collaboration-river">
        <River.Visual className="Collaboration-riverVisual">
          <img src="/images/modules/site/home24/collaboration/river-1.webp" alt="TODO" />
        </River.Visual>

        <River.Content className="Collaboration-riverContent">
          <Heading size="6">Keep track of your tasks</Heading>
          <Text size="300">Create issues and manage projects with tools that adapt to your code.</Text>
          <Link href="#TODO">Explore GitHub Issues</Link>
        </River.Content>
      </River>
    </Section>
  )
}

try{ Collaboration.displayName ||= 'Collaboration' } catch {}